import PropTypes from 'prop-types';
import {
    Box,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Button,
    List,
    ListItem,
    ListItemText,
    Checkbox,
    Divider
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { useState } from 'react';

export default function TaskLabels({ selectedLabels, onChange, labelOptions }) {
    const [ dialogOpen, setDialogOpen ] = useState(false);

    const toggleDialog = () => setDialogOpen(!dialogOpen);

    const handleToggleLabel = (labelName) => {
        const newSelected = selectedLabels.includes(labelName)
            ? selectedLabels.filter((label) => label !== labelName)
            : [ ...selectedLabels, labelName ];

        onChange(newSelected);
    };

    return (
        <Box sx={ { mb: 2 } }>
            <Box sx={ { display: 'flex', flexWrap: 'wrap', gap: 1 } }>
                { selectedLabels.map((label) => {
                    const option = labelOptions.find(opt => opt.name === label);
                    return (
                        <Chip
                            key={ label }
                            label={ label }
                            size="small"
                            sx={ {
                                bgcolor: option?.color || '#f44336',
                                color: 'white'
                            } }
                        />
                    );
                }) }
                <IconButton size="small" onClick={ toggleDialog }>
                    <Iconify icon="mdi:plus" />
                </IconButton>
            </Box>

            <Dialog
                open={ dialogOpen }
                onClose={ toggleDialog }
                PaperProps={ { sx: { width: 400, maxWidth: '100%', padding: 1 } } }
            >
                <DialogTitle>
                    Labels
                    <IconButton
                        onClick={ toggleDialog }
                        sx={ { position: 'absolute', right: 8, top: 8 } }
                    >
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={ { p: 2 } }>
                    <List sx={ { pt: 0, p: 2 } }>
                        { labelOptions.map((label) => (
                            <ListItem
                                key={ label.id }
                                dense
                                disablePadding
                                sx={ {
                                    mb: 1,
                                    p: 1,
                                    bgcolor: label.color,
                                    color: 'white',
                                    borderRadius: 1,
                                    height: 36
                                } }
                            >
                                <Checkbox
                                    edge="start"
                                    checked={ selectedLabels.includes(label.name) }
                                    onChange={ () => handleToggleLabel(label.name) }
                                    sx={ { color: 'white' } }
                                />
                                <ListItemText primary={ label.name } />
                                <IconButton size="small" sx={ { color: 'white' } }>
                                    <Iconify icon="mdi:pencil" />
                                </IconButton>
                            </ListItem>
                        )) }
                    </List>

                    <Divider sx={ { my: 2 } } />

                    <Button fullWidth variant="outlined">
                        Create a new label
                    </Button>

                    <Button fullWidth variant="text" sx={ { mt: 1 } }>
                        Enable colorblind friendly mode
                    </Button>
                </DialogContent>
            </Dialog>
        </Box>
    );
}

TaskLabels.propTypes = {
    selectedLabels: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    labelOptions: PropTypes.array.isRequired
};
